<template>
    <div class="SetupProfile">
        <h2>{{lang.signup.welcome.header.replace('{0}', providerName)}}</h2>
        <p class="spacingBeforeInputs littleAndBold">{{lang.signup.welcome.introText}}</p>

        <Input dataKey="description" type="textarea" :label="lang.signup.welcome.description.label" :helperText="lang.signup.welcome.description.helperText" optional />
        <Input dataKey="website" :label="lang.signup.welcome.website.label" :placeholder="lang.signup.welcome.website.placeholder" :helperText="lang.signup.welcome.website.helperText" optional />
        <Input dataKey="address" @input="onAddressInput" :label="lang.signup.welcome.address.label" :helperText="lang.signup.welcome.address.helperText" :placeholder="lang.signup.welcome.address.placeholder" :validationFunction="addressValidation" />

        <div class="nextPageControls">
            <Button class="onlyText" @click="$router.push('account')">{{lang.signup.button.back}}</Button>
            <Button :disabled="!validatePage" @click="$router.push('location')">{{lang.signup.button.continue}}</Button>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import Input from '../components/Input.vue'
import Button from '../components/Button.vue'
import Checkbox from '../components/Checkbox.vue'
import lang from '../lang'
import { throttle } from '../util/limiter'
import {postalCodeFromGooglePlace} from '../util/googleApis'

export default {
	name: 'SetupProfile',
	props: [],
	data: () => ({
		lang,
		locationUpdated: true
	}),
	computed: {
		providerName() {
			return this.$store.state.name
		},
		validatePage() {
			let address = this.$store.state.address
			return address && !this.addressValidation(address) && this.locationUpdated
		}
	},
	methods: {
		...mapActions(['setPartnerDataValue']),
		addressValidation(address) {
			if (address && address.length < 5) {
				return lang.signup.validation.required
			}
		},
		// Write value directly to store without waiting for esc/tab/click so that next button would be green when address is filled
		onAddressInput(address) {
			this.locationUpdated = false
			this.setPartnerDataValue({ key: 'address', value: address })

			this.throttledLocationSearch(address)
		},

		throttledLocationSearch(address) {
			let query = `${address} ${this.$store.state.city}`

			let geocoder = new window.google.maps.Geocoder()
			geocoder.geocode({ address: query }, (results, status) => {
				if (status === window.google.maps.GeocoderStatus.OK) {
					if (results.length >= 1) {
						let lat = results[0].geometry.location.lat()
						let lng = results[0].geometry.location.lng()
						let postalCode = postalCodeFromGooglePlace(results[0])

						this.setPartnerDataValue({ key: 'latitude', value: lat })
						this.setPartnerDataValue({ key: 'longitude', value: lng })
						this.setPartnerDataValue({ key: 'postalCode', value: postalCode })

						this.locationUpdated = true
					}
				}
			})
		}
	},
	mounted() {
		this.throttledLocationSearch = throttle(this.throttledLocationSearch, 500)
	},
	components: {
		Input,
		Button,
		Checkbox,
	},
}
</script>

<style lang="stylus" scoped>
.SetupProfile {
	max-width: 400px;
	margin: 0 auto;
}
</style>
